import script from "./PointsSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsSettings.vue?vue&type=script&setup=true&lang=js"

import "./PointsSettings.vue?vue&type=style&index=0&id=496a4014&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-496a4014"]])

export default __exports__